import { MonthYear } from "@common/types";
import { ICommandBase } from "@Quest/cqrs";

export class UpdateProjectActivePlanCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateProjectActivePlanCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	OldActivePlanId: string;
	NewActivePlanId: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string, oldActivePlanId: string, newActivePlanId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.OldActivePlanId = oldActivePlanId;
		this.NewActivePlanId = newActivePlanId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateProjectActivePlanCommandV1, TCh.Domain.Quest'
	}
}


export class CreateProjectPlanCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.CreateProjectPlanCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;

	PlanId: string;
	PlanName: string;
	DurationInMonths: number;
	Granularity: string;
	Denomination: string;
	PlanningHorizonInYears: number;
	SubmissionDueDateIsoString: string | null;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, planId: string, planName: string, durationInMonths: number, granularity: string,
		denomination: string, planningHorizonInYears: number, submissionDueDateIsoString: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;

		this.PlanId = planId;
		this.PlanName = planName;
		this.DurationInMonths = durationInMonths;
		this.Granularity = granularity;
		this.Denomination = denomination;
		this.PlanningHorizonInYears = planningHorizonInYears;
		this.SubmissionDueDateIsoString = submissionDueDateIsoString;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.CreateProjectPlanCommandV1, TCh.Domain.Quest';
	}
}

export class CloneProjectPlanCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.CloneProjectPlanCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	SourcePlanId: string;
	ClonePlanId: string;
	ClonePlanName: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string, sourcePlanId: string, clonePlanId: string, clonePlanName: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.SourcePlanId = sourcePlanId;
		this.ClonePlanId = clonePlanId;
		this.ClonePlanName = clonePlanName;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.CloneProjectPlanCommandV1, TCh.Domain.Quest';
	}
}

export class DeleteProjectPlanCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.DeleteProjectPlanCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;

	PlanId: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, planId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;
		this.PlanId = planId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.DeleteProjectPlanCommandV1, TCh.Domain.Quest'
	}
}

export class ExportProjectPlanCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.ExportProjectPlanCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;
	ProjectPlanId: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;
		this.ProjectPlanId = projectPlanId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.ExportProjectPlanCommandV1, TCh.Domain.Quest'
	}
}

export class UpdateProjectPlanCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateProjectPlanCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;

	PlanId: string;
	PlanName: string;
	DurationInMonths: number;
	Granularity: string;
	Denomination: string;
	PlanningHorizonInYears: number;
	SubmissionDueDateIsoString: string | null;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, planId: string, planName: string,
		durationInMonths: number, granularity: string, denomination: string, planningHorizonInYears: number, submissionDueDateIsoString: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;

		this.PlanId = planId;
		this.PlanName = planName;
		this.DurationInMonths = durationInMonths;
		this.Granularity = granularity;
		this.Denomination = denomination;
		this.PlanningHorizonInYears = planningHorizonInYears;
		this.SubmissionDueDateIsoString = submissionDueDateIsoString;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateProjectPlanCommandV1, TCh.Domain.Quest';
	}
}

export class SubmitProjectPlanCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SubmitProjectPlanCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	PlanId: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string, planId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.PlanId = planId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SubmitProjectPlanCommandV1, TCh.Domain.Quest'
	}
}

export class UnsubmitProjectPlanCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UnsubmitProjectPlanCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	PlanId: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string, planId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.PlanId = planId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UnsubmitProjectPlanCommandV1, TCh.Domain.Quest'
	}
}


export class UpdateBenefitsConfidenceFactorCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateBenefitsConfidenceFactorCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;
	PlanId: string;
	BenefitsConfidenceFactor: number | null;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, planId: string, benefitsConfidenceFactor: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;
		this.PlanId = planId;
		this.BenefitsConfidenceFactor = benefitsConfidenceFactor;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateBenefitsConfidenceFactorCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateProjectRevenuesCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateProjectRevenuesCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;

	ProjectPlanId: string;
	Granularity: string;
	Denomination: string;
	Entries: string[];
	Comment: string | null;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string, granularity: string,
		denomination: string, entries: string[], comment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;

		this.ProjectPlanId = projectPlanId;
		this.Granularity = granularity;
		this.Denomination = denomination;
		this.Entries = entries;
		this.Comment = comment;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateProjectRevenuesCommandV1, TCh.Domain.Quest'
	}
}

export class UpdateProjectMarginsCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateProjectMarginsCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;
	ProjectPlanId: string;
	Granularity: string;
	Entries: string[];
	Comment: string | null;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string, granularity: string, entries: string[], comment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;
		this.ProjectPlanId = projectPlanId;
		this.Granularity = granularity;
		this.Entries = entries;
		this.Comment = comment;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateProjectMarginsCommandV1, TCh.Domain.Quest'
	}
}


export class UpdateProjectResourceSavingsCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateProjectResourceSavingsCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;
	ProjectPlanId: string;
	Granularity: string;
	Entries: string[];
	Comment: string | null;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string, granularity: string, entries: string[], comment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;

		this.ProjectPlanId = projectPlanId;
		this.Granularity = granularity;
		this.Entries = entries;
		this.Comment = comment;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateProjectResourceSavingsCommandV1, TCh.Domain.Quest'
	}
}

export class UpdateProjectResourceUnitCostsCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateProjectResourceUnitCostsCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;
	ProjectPlanId: string;
	FromYear: number;
	Entries: string[];
	Comment: string | null;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string, fromYear: number, entries: string[], comment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;

		this.ProjectPlanId = projectPlanId;
		this.FromYear = fromYear;
		this.Entries = entries;
		this.Comment = comment;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateProjectResourceUnitCostsCommandV1, TCh.Domain.Quest'
	}
}

export class UpdateProjectExpenseAllocationsCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateProjectExpenseAllocationsCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;

	ProjectPlanId: string;
	Granularity: string;
	Denomination: string;
	Entries: string[];
	Comment: string | null;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string, granularity: string, denomination: string,
		entries: string[], comment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;

		this.ProjectPlanId = projectPlanId;
		this.Granularity = granularity;
		this.Denomination = denomination;
		this.Entries = entries;
		this.Comment = comment;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateProjectExpenseAllocationsCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateProjectExpenseSavingsCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateProjectExpenseSavingsCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;

	ProjectPlanId: string;
	Granularity: string;
	Denomination: string;
	Entries: string[];
	Comment: string | null;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string, granularity: string, denomination: string,
		entries: string[], comment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;

		this.ProjectPlanId = projectPlanId;
		this.Granularity = granularity;
		this.Denomination = denomination;
		this.Entries = entries;
		this.Comment = comment;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateProjectExpenseSavingsCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateProjectResourceAllocationsCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateProjectResourceAllocationsCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;

	ProjectPlanId: string;
	Granularity: string;
	Entries: string[];
	Comment: string | null;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string, granularity: string, entries: string[], comment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;

		this.ProjectPlanId = projectPlanId;
		this.Granularity = granularity;
		this.Entries = entries;
		this.Comment = comment;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateProjectResourceAllocationsCommandV1, TCh.Domain.Quest';
	}
}


export class CreateProjectCapexItemCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.CreateProjectCapexItemCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;

	ProjectPlanId: string;
	CapexAccountId: string;
	ItemId: string;
	Name: string;
	Cost: number;
	AcquisitionMonthIndex: number;
	SalvageValue: number;
	UsefulLifeInYears: number;
	DepreciationMethod: string;
	Denomination: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string, capexAccountId: string, itemId: string, name: string, cost: number,
		acquisitionMonthIndex: number, salvageValue: number, usefulLifeInYears: number, depreciationMethod: string, denomination: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;

		this.ProjectPlanId = projectPlanId;
		this.CapexAccountId = capexAccountId;
		this.ItemId = itemId;
		this.Name = name;
		this.Cost = cost;
		this.AcquisitionMonthIndex = acquisitionMonthIndex;
		this.SalvageValue = salvageValue;
		this.UsefulLifeInYears = usefulLifeInYears;
		this.DepreciationMethod = depreciationMethod;
		this.Denomination = denomination;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.CreateProjectCapexItemCommandV1, TCh.Domain.Quest';
	}
}

export class DeleteProjectCapexItemCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.DeleteProjectCapexItemCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;
	ProjectPlanId: string;
	ItemId: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string, itemId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;

		this.ProjectPlanId = projectPlanId;
		this.ItemId = itemId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.DeleteProjectCapexItemCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateProjectCapexItemCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateProjectCapexItemCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	ActivePlanId: string;

	ProjectPlanId: string;
	CapexAccountId: string;
	ItemId: string;
	Name: string;
	Cost: number;
	AcquisitionMonthIndex: number;
	SalvageValue: number;
	UsefulLifeInYears: number;
	DepreciationMethod: string;
	Denomination: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string,
		projectPlanId: string, capexAccountId: string, itemId: string, name: string, cost: number, acquisitionMonthIndex: number, salvageValue: number, usefulLifeInYears: number, depreciationMethod: string, denomination: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.ActivePlanId = activePlanId;

		this.ProjectPlanId = projectPlanId;
		this.CapexAccountId = capexAccountId;
		this.ItemId = itemId;
		this.Name = name;
		this.Cost = cost;
		this.AcquisitionMonthIndex = acquisitionMonthIndex;
		this.SalvageValue = salvageValue;
		this.UsefulLifeInYears = usefulLifeInYears;
		this.DepreciationMethod = depreciationMethod;
		this.Denomination = denomination;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateProjectCapexItemCommandV1, TCh.Domain.Quest';
	}
}




export class SetLifecycleProposalCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleProposalCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;

	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleProposalCommandV1, TCh.Domain.Quest';
	}
}

export class SetLifecycleQualifiedCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleQualifiedCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;

	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleQualifiedCommandV1, TCh.Domain.Quest';
	}
}

export class SetLifecycleRejectedCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleRejectedCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;

	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleRejectedCommandV1, TCh.Domain.Quest';
	}
}

export class SetLifecycleScheduledCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleScheduledCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	StartDate: MonthYear;

	constructor(workspaceId: number, portfolioId: string, projectId: string, startDate: MonthYear)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.StartDate = startDate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleScheduledCommandV1, TCh.Domain.Quest';
	}
}

export class SetLifecycleInProgressCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleInProgressCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;
	StartDate: MonthYear;

	constructor(workspaceId: number, portfolioId: string, projectId: string, startDate: MonthYear)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
		this.StartDate = startDate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleInProgressCommandV1, TCh.Domain.Quest';
	}
}

export class SetLifecyclePausedCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecyclePausedCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecyclePausedCommandV1, TCh.Domain.Quest';
	}
}

export class SetLifecycleResumedCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleResumedCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleResumedCommandV1, TCh.Domain.Quest';
	}
}

export class SetLifecycleTerminatedCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleTerminatedCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleTerminatedCommandV1, TCh.Domain.Quest';
	}
}

export class SetLifecycleCompletedCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleCompletedCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	PortfolioId: string;
	Id: string;

	constructor(workspaceId: number, portfolioId: string, projectId: string)
	{
		this.WorkspaceId = workspaceId;
		this.PortfolioId = portfolioId;
		this.Id = projectId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleCompletedCommandV1, TCh.Domain.Quest';
	}
}

